import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import Card from 'kpc/components/card';
import { Row, Col } from 'kpc/components/grid';
import Icon from 'kpc/components/icon';
import { Tooltip } from 'kpc/components/tooltip';

import CopyIcon from '../../../components/CopyIcon/index.vue'

import * as _ from 'lodash';
import apiRequest from "../../../service/vpc/request";
import trustApiRequest from "../../../service/trust_vpc/request";
import SubViewJumper from "../../../views/__mixins/SubViewJumper";
import * as subnetService from "../../../service/vpc/subnet";

let subnetTypes = subnetService.getSubnetTypes();

@Component({
    components: {
        Card,
        Row, Col,
        Icon,
        Tooltip,
        CopyIcon
    },
    mixins: [SubViewJumper]
})
export default class groupDetailInfoView extends Vue {
    region = ''
    vpc: any = {}
    subnet: any = {}
    subnetId = ''
    SecurityGroupTypeList = {
        default: this.$trans('默认安全组'),
        other: this.$trans('普通安全组'),
        global: this.$trans('全局安全组')
    }
    
    async mounted() {
        this.region = this.$route.params.region;
        this.subnetId = this.$route.params.subnetId;
        this.vpcId = this.$route.params.vpcId;
        await this.QuerySubnet();
        if(this.vpcId != 0) {
            await this.DescribeVpc();
        }
    }

    get isTrustVpc(){
        return this.$route.path.indexOf('trust-vpc') !== -1
    }

    get request() {
        return this.isTrustVpc ? trustApiRequest : apiRequest
    }

    getDetailValue(key: string) {
        return _.get(this.$parent.detail, key, '-');
    }

    getVpc() {
        return _.get(this.vpc, 'VpcName', '-')
    }

    QuerySubnet() {
        return new Promise(resolve => {
            // apiRequest.QuerySubnet({
            this.request.QuerySubnet({
                Region: this.region,
                'SubnetId.1': this.subnetId
            }).done((data: any) => {
                this.subnet = data || {}
                resolve(data)
            })
        })
    }

    DescribeVpc() {
        return new Promise(resolve => {
            // apiRequest.DescribeVpcs({
            this.request.DescribeVpcs({
                Region: this.region,
                'VpcId.1': this.vpcId
            }).done((data: any) => {
                this.vpc = _.get(data, 'vpcSet[0]', {})
                resolve(data)
            })
        })
    }

    go2tab(tab: string, key?: string) {
        this.$parent.goTo(tab, key);
    }
}
